const header = document.querySelector("[data-background-target]");
const initHeaderOneLevelComponent = () => {
    //activates in homepage only
    if (document.querySelector(".homepage")) {
        isDocumentAtTop();
        document.addEventListener("scroll", () => {
            isDocumentAtTop();
        });
    }
};
const isDocumentAtTop = () => {
    if (window.pageYOffset != 0) {
        header.classList.add("scrolled");
    }
    else {
        header.classList.remove("scrolled");
    }
};
